import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { NotesRounded } from "@mui/icons-material";
import { keyframes } from "@mui/system";
import { primaryDark, accentColor } from "../../../constants/consts";

const popIn = keyframes`
  from { opacity: 0; transform: scale(0.92); }
  to   { opacity: 1; transform: scale(1); }
`;

export default function SupportNotesDialog({
  open,
  onClose,
  title,
  note,
  summary,
}) {
  const hasNote = !!note?.trim();
  const hasSummary = !!summary?.trim();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          animation: `${popIn} 0.25s cubic-bezier(0.22, 1, 0.36, 1) both`,
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          px: 3,
          py: 1.75,
          background: `linear-gradient(135deg, ${primaryDark} 0%, ${accentColor} 100%)`,
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            color: "#fff",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <NotesRounded sx={{ fontSize: 20 }} />
          Konu: {title || "-"}
        </DialogTitle>
      </Box>

      <DialogContent sx={{ pt: 3 }}>
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: 13,
            color: "#334155",
            mb: 1,
          }}
        >
          Not
        </Typography>
        {hasNote ? (
          <Box
            sx={{
              p: 1.75,
              borderRadius: 2,
              backgroundColor: "#EEF2FF",
              color: "#1E293B",
              fontSize: 13,
              lineHeight: 1.5,
              mb: 3,
              whiteSpace: "pre-wrap",
            }}
          >
            {note}
          </Box>
        ) : (
          <Box sx={{ mb: 3, color: "#94A3B8", fontSize: 12.5 }}>
            Not girilmemiş
          </Box>
        )}

        <Typography
          sx={{
            fontWeight: 800,
            fontSize: 13,
            color: "#334155",
            mb: 1,
          }}
        >
          İşin Özeti
        </Typography>
        {hasSummary ? (
          <Box
            sx={{
              p: 1.75,
              borderRadius: 2,
              backgroundColor: "#EEF2FF",
              color: "#1E293B",
              fontSize: 13,
              lineHeight: 1.5,
              whiteSpace: "pre-wrap",
            }}
          >
            {summary}
          </Box>
        ) : (
          <Box sx={{ color: "#94A3B8", fontSize: 12.5 }}>Özet girilmemiş</Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 4,
            fontWeight: 700,
          }}
        >
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
}
